<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import Stat from "./widget";
import RevenueLocation from "./revenue-location";
import CustomerTaskImport from './customer-task-imports';

/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Stat,
    RevenueLocation,
    CustomerTaskImport
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Adidas"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      formula: '',
      resultado: null,
    };
  },
  methods: {
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <Stat />
      </div>
      <div class="col-xl-8">
        <CustomerTaskImport />
      </div>
      <div class="col-xl-4">
        <RevenueLocation />
      </div>
    </div>
  </Layout>
</template>